import { render, staticRenderFns } from "./TreeCourseDetails.vue?vue&type=template&id=b9b5cbde&"
import script from "./TreeCourseDetails.vue?vue&type=script&lang=js&"
export * from "./TreeCourseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports